import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { AuthInitialState } from './auth.state';

const initialState: AuthTypes = AuthInitialState;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTH: (state, action: PayloadAction<string>) => {
      state.jwtToken = action.payload;
    },
    SET_ACCOUNT: (state, action: PayloadAction<{ userId: number; verification: IUserPortal }>) => {
      state.userId = action.payload.userId;
      state.tokenVerification = action.payload.verification;
    },
    // SET_PERMISSION: (state, action: PayloadAction<boolean>) => {
    //   state.isAdmin = action.payload;
    // },
  },
});

export default authSlice.reducer;
